"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LessonBoard_exports = {};
__export(LessonBoard_exports, {
  default: () => LessonBoard_default
});
module.exports = __toCommonJS(LessonBoard_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 5.2H20C20.4418 5.2 20.8 5.55817 20.8 6V13C20.8 13.4418 20.4418 13.8 20 13.8H4C3.55817 13.8 3.2 13.4418 3.2 13V6C3.2 5.55817 3.55817 5.2 4 5.2ZM2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V13C22 14.1046 21.1046 15 20 15H15.7211L18.4992 19.1672C18.683 19.4429 18.6085 19.8154 18.3328 19.9992C18.0571 20.1831 17.6846 20.1086 17.5008 19.8328L16.3455 18.0999H12.6V19.4999C12.6 19.8313 12.3314 20.0999 12 20.0999C11.6686 20.0999 11.4 19.8313 11.4 19.4999V18.0999H7.65444L6.49923 19.8327C6.31542 20.1084 5.94289 20.1829 5.66718 19.9991C5.39146 19.8153 5.31695 19.4428 5.50077 19.1671L8.27882 15H4C2.89543 15 2 14.1046 2 13V6ZM9.72105 15L8.45444 16.8999H11.4V15H9.72105ZM12.6 15V16.8999L15.5455 16.8999L14.2789 15H12.6Z",
      fill: "currentColor"
    }
  )
);
const SvgLessonBoard = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LessonBoard_default = SvgLessonBoard;
